var _polygon, _polygon2;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgBetslipLive = function SvgBetslipLive(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "583.003px",
    height: "212.604px",
    viewBox: "0 0 583.003 212.604",
    enableBackground: "new 0 0 583.003 212.604",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("linearGradient", {
    id: "live_match_grad_2",
    gradientUnits: "userSpaceOnUse",
    x1: 65.8506,
    y1: 106.3018,
    x2: 583.0029,
    y2: 106.3018
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#ff196e"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7163,
    style: {
      stopColor: "#FFFFFF",
      stopOpacity: 0
    }
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "url(#live_match_grad_2)",
    points: "583.003,0 487.422,0 249.971,0 191,0 65.851,212.603 249.971,212.603 487.422,212.603  487.422,212.604 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#ff196e",
    points: "31,0 0,0 0,212.604 31,212.604 156.333,0 "
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBetslipLive, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDE2LjAuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8IURPQ1RZUEUgc3ZnIFBVQkxJQyAiLS8vVzNDLy9EVEQgU1ZHIDEuMS8vRU4iICJodHRwOi8vd3d3LnczLm9yZy9HcmFwaGljcy9TVkcvMS4xL0RURC9zdmcxMS5kdGQiPgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgoJIHdpZHRoPSI1ODMuMDAzcHgiIGhlaWdodD0iMjEyLjYwNHB4IiB2aWV3Qm94PSIwIDAgNTgzLjAwMyAyMTIuNjA0IiBlbmFibGUtYmFja2dyb3VuZD0ibmV3IDAgMCA1ODMuMDAzIDIxMi42MDQiCgkgeG1sOnNwYWNlPSJwcmVzZXJ2ZSI+CjxsaW5lYXJHcmFkaWVudCBpZD0ibGl2ZV9tYXRjaF9ncmFkXzIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIiB4MT0iNjUuODUwNiIgeTE9IjEwNi4zMDE4IiB4Mj0iNTgzLjAwMjkiIHkyPSIxMDYuMzAxOCI+Cgk8c3RvcCAgb2Zmc2V0PSIwIiBzdHlsZT0ic3RvcC1jb2xvcjojZmYxOTZlIi8+Cgk8c3RvcCAgb2Zmc2V0PSIwLjcxNjMiIHN0eWxlPSJzdG9wLWNvbG9yOiNGRkZGRkY7c3RvcC1vcGFjaXR5OjAiLz4KPC9saW5lYXJHcmFkaWVudD4KPHBvbHlnb24gZmlsbD0idXJsKCNsaXZlX21hdGNoX2dyYWRfMikiIHBvaW50cz0iNTgzLjAwMywwIDQ4Ny40MjIsMCAyNDkuOTcxLDAgMTkxLDAgNjUuODUxLDIxMi42MDMgMjQ5Ljk3MSwyMTIuNjAzIDQ4Ny40MjIsMjEyLjYwMyAKCTQ4Ny40MjIsMjEyLjYwNCAiLz4KPHBvbHlnb24gZmlsbD0iI2ZmMTk2ZSIgcG9pbnRzPSIzMSwwIDAsMCAwLDIxMi42MDQgMzEsMjEyLjYwNCAxNTYuMzMzLDAgIi8+Cjwvc3ZnPgo=";
export { ForwardRef as ReactComponent };